
import { useState } from 'react';

// Mock data generation hook
export const useConsumptionData = (userId: string) => {
  const [timeRange, setTimeRange] = useState<'month' | 'quarter' | 'year'>('month');
  const [hideConsumption, setHideConsumption] = useState(false);
  
  // This would normally fetch data based on the userId and timeRange
  // Mock data for demonstration
  const getConsumptionData = () => {
    if (timeRange === 'month') {
      return [
        { day: '1', consumption: 15 },
        { day: '5', consumption: 18 },
        { day: '10', consumption: 13 },
        { day: '15', consumption: 17 },
        { day: '20', consumption: 14 },
        { day: '25', consumption: 19 },
        { day: '30', consumption: 16 },
      ];
    } else if (timeRange === 'quarter') {
      return [
        { month: 'Jan', consumption: 450 },
        { month: 'Feb', consumption: 475 },
        { month: 'Mar', consumption: 430 },
        { month: 'Apr', consumption: 450 },
      ];
    } else {
      return [
        { month: 'Jan', consumption: 450 },
        { month: 'Feb', consumption: 475 },
        { month: 'Mar', consumption: 430 },
        { month: 'Apr', consumption: 450 },
        { month: 'May', consumption: 410 },
        { month: 'Jun', consumption: 490 },
        { month: 'Jul', consumption: 520 },
        { month: 'Aug', consumption: 510 },
        { month: 'Sep', consumption: 470 },
        { month: 'Oct', consumption: 440 },
        { month: 'Nov', consumption: 460 },
        { month: 'Dec', consumption: 480 },
      ];
    }
  };

  // Toggle consumption visibility
  const toggleConsumptionVisibility = () => {
    setHideConsumption(!hideConsumption);
  };

  return {
    timeRange,
    setTimeRange,
    hideConsumption,
    toggleConsumptionVisibility,
    consumptionData: getConsumptionData()
  };
};
